const { primitives } = require('../../primitives')

const contentVariables = {
  action: {
    default: primitives['neon-blue'][500],
    'default-hover': primitives['neon-blue'][600],
    'on-default': primitives['neutral'][0],
    dark: primitives['neon-blue'][800],
    subtle: primitives['neon-blue'][200],
    light: primitives['neon-blue'][100],
  },
  positive: {
    default: primitives['green'][700],
    'default-hover': primitives['green'][800],
    'on-default': primitives['neutral'][0],
    dark: primitives['green'][900],
    subtle: primitives['green'][200],
    light: primitives['green'][100],
  },
  neutral: {
    default: primitives['neutral'][700],
    'default-hover': primitives['neutral'][800],
    'on-default': primitives['neutral'][0],
    dark: primitives['neutral'][800],
    subtle: primitives['neutral'][400],
    light: primitives['neutral'][300],
  },
  warning: {
    default: primitives['coral'][500],
    'default-hover': primitives['coral'][600],
    'on-default': primitives['coral'][900],
    dark: primitives['coral'][800],
    subtle: primitives['coral'][200],
    light: primitives['coral'][100],
  },
  alert: {
    default: primitives['red'][600],
    'default-hover': primitives['red'][700],
    'on-default': primitives['neutral'][0],
    dark: primitives['red'][800],
    subtle: primitives['red'][200],
    light: primitives['red'][100],
  },
  discovery: {
    default: primitives['lime'][500],
    'default-hover': primitives['lime'][600],
    'on-default': primitives['forest'][900],
    dark: primitives['lime'][1000],
    subtle: primitives['lime'][200],
    light: primitives['lime'][100],
  },
  info: {
    default: primitives['water'][800],
    'default-hover': primitives['water'][900],
    'on-default': primitives['neutral'][0],
    dark: primitives['water'][900],
    subtle: primitives['water'][200],
    light: primitives['water'][100],
  },
}

module.exports = { contentVariables }
